@if (loaded) {
<nb-card accent="warning">
  <nb-card-body>
    <h4 translate="authPages.alternativeMember.title"></h4>
    <p
      [innerHTML]="
        'alerts.alternativeCourseMemberRequired'
          | translate : { currentContext }
      "
    ></p>
    @if (courseMembers) {
    <nb-list>
      @for (courseMember of courseMembers; track courseMember) {
      <nb-list-item (click)="selectTeam(courseMember.team?.id)">
        <nb-user
          [name]="courseMember.name"
          [picture]="courseMember.profilePicturePreviewUrl"
          shape="rectangle"
        ></nb-user>
      </nb-list-item>
      }
    </nb-list>
    }
  </nb-card-body>
</nb-card>
}
